import { dateColumn, textareaColumn } from "./columnHelpers";

export const tasksRelationship = {
    collapsible: false,
    title: 'Tasks',
    tint: 'default',
    type: 'tasks',
};

/*
export const tasksRelationshipEdit = {
    collapsible: false,
    title: 'Tasks',
    tint: 'default',
    type: 'table',
    sx: {
        '--mm-card-height': 'auto',
    },
    columns: [
        // task name // & assignees
        dateColumn({
            label: 'Due',
            column: 'due_date',
        }),
        // budget


        // textColumn({label: 'Unit', column: 'unit'}),
        textColumn({label: 'Unit', column: 'unit', secondaryColumn: 'notes'}),
        genericColumn({
            label: 'Residential',
            type: 'custom',
            render: {
                edit: ({rowIndex, row, data, setRowValue}) => {
                    const isResidential = !!row.residential;
                    const isOccupied = !!row.occupied;
                    return (<>
                        <Typography sx={{userSelect: 'none',}} component="label" startDecorator={
                          <Switch
                            // key={cellIndex}
                            variant={'solid'}
                            onChange={(e) => {
                              setRowValue(rowIndex, 'residential', isResidential ? 0 : 1)
                              if(!isResidential) {
                                setRowValue(rowIndex, 'occupied', 0)
                              }
                            }}
                            checked={isResidential}
                          />
                        }>
                          Residential
                        </Typography>
                        <Typography sx={{userSelect: 'none', mt: 0.5}} component="label" startDecorator={
                          <Switch
                            // key={cellIndex}
                            variant={'solid'}
                            disabled={!isResidential}
                            onChange={(e) => {
                              setRowValue(rowIndex, 'occupied', isOccupied ? 0 : 1)
                            }}
                            checked={isResidential && isOccupied}
                            sx={theme => ({
                                '--variant-solidDisabledBg': 'var(--joy-palette-neutral-300)',
                                '--variant-solidDisabledColor': 'var(--joy-palette-neutral-50)',
                            })}
                          />
                        }>
                          Occupied
                        </Typography>
                    </>)
                },
            },
        }),

        textareaColumn({
            label: 'Notes',
            column: 'notes',
        }),
    ],
};
*/
